export default __webpack_public_path__ + "static/media/chibuzor.43b28e6c.jpg";